import {
  faCheck,
  faExclamation,
  faTimes,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import css from './notice.module.css';

export default function Notice({
  text,
  status,
  className,
  onDismiss,
}: {
  text: string;
  status?: 'success' | 'warning' | 'error';
  className?: string;
  onDismiss?: () => void;
}) {
  function icon(status: string) {
    switch (status) {
      case 'success':
        return faCheck;
      case 'warning':
        return faExclamation;
      case 'error':
        return faTimes;
      default:
        return null;
    }
  }

  return (
    <div className={`${css['notice']} ${css[status]} ${className}`}>
      <div className={css['text']}>
        <FontAwesomeIcon icon={icon(status)} />
        {text}
      </div>
      <div className={css['close']} onClick={onDismiss}>
        <FontAwesomeIcon icon={faTimes} />
      </div>
    </div>
  );
}
